export default __webpack_public_path__ + "static/media/file_download_black_24dp.844f9ccc.svg";